import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Layout from './components/Layout';

const ProtectedRoute = () => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return <Navigate to="/login" />;
  }
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default ProtectedRoute;
